<template>
  <div>
    <v-layout row wrap class="pl-4 pt-2">
      <v-flex  xs2>
        <span class="d-block font-weight-bold">Quantidade</span>
        <span>{{ quantidadeFormatada }}</span>
      </v-flex>
      <v-flex  xs2 v-if="itemEhPeriodico">
        <span class="d-block font-weight-bold">Periodicidade</span>
        <div class="periodicidade-acompanhamento">
          <span>{{ mesesPeriodicidade }} {{ mesesPeriodicidade > 1 ? 'meses' : 'mês' }}</span>
          <v-tooltip top max-width="320" content-class="tooltip-periodicidade-acompanhamento">
            <v-icon slot="activator" class="periodicidade-acompanhamento__icone">info_outline</v-icon>
            <div>
              <div class="tooltip-periodicidade-acompanhamento__titulo">Periodicidade (informativo)</div>
              <div>Período: {{ mesesPeriodicidade }} {{ mesesPeriodicidade > 1 ? 'meses' : 'mês' }}</div>
              <div>Valor total do período: {{ valorTotalPeriodoFormatado }}</div>
              <div>Valor médio mensal: {{ valorMedioMensalFormatado }}</div>
              <div class="tooltip-periodicidade-acompanhamento__divisor"></div>
              <div class="tooltip-periodicidade-acompanhamento__aviso">
                Informação apenas para consulta.<br>
                Não altera os valores da licitação.
              </div>
            </div>
          </v-tooltip>
        </div>
      </v-flex>
      <v-flex  xs2>
        <span class="d-block font-weight-bold">Valor Unitário Estimado</span>
        <span v-if="acompanhamentoDetalhes.mostrarValorReserva">
          R$ {{ valorFormatado(this.acompanhamentoDetalhes.valorUnitarioEstimado, this.acompanhamentoDetalhes.casasDecimais) }}</span>
        <span v-else>Sigiloso</span>
      </v-flex>
      <v-flex  xs2>
        <span class="d-block font-weight-bold">Valor Total Estimado</span>
        <span v-if="acompanhamentoDetalhes.mostrarValorReserva">
          R$ {{ valorFormatado(this.acompanhamentoDetalhes.valorTotalEstimado, this.acompanhamentoDetalhes.casasDecimais) }}</span>
        <span v-else>Sigiloso</span>
      </v-flex>
      <v-flex  xs2 v-if="situacao === 'ENCERRADA'">
        <span class="d-block font-weight-bold">Valor Total Final</span>
        <span>R$ {{ valorFormatado(this.acompanhamentoDetalhes.valorTotalFinal, this.acompanhamentoDetalhes.casasDecimais) }}</span>
      </v-flex>
    </v-layout>
    <div v-if="itemEhPeriodico" class="legenda-periodicidade px-4">
      <v-icon color="primary">info_outline</v-icon>
      <div>
        <div><strong class="legenda-periodicidade__titulo">Periódico:</strong> o valor total informado corresponde ao período indicado ao lado do item.</div>
        <div>Exemplo: item com período de 10 meses e valor total de R$ 100.000,00 = valor médio mensal de R$ 10.000,00 (apenas informativo).</div>
      </div>
    </div>
    <div style="width: 100%" class="px-4 pt-2">
      <hr class="mx-0" />
    </div>
    <div class="px-4 pb-3" v-if="exibirRelatorioHistoricoLancesAreaPublica || exibirRelatorioParticipantesAreaPublica || exibirDocumentosFornecedorVencedor">
      <v-btn color="primary" v-if="exibirRelatorioHistoricoLancesAreaPublica && !ehMelhorTecnica && loteAposFaseLances" @click="acaoImprimirHistorico">
        Imprimir Histórico de Lances
      </v-btn>
      <v-btn color="primary" v-if="exibirRelatorioParticipantesAreaPublica && situacao !== 'AGENDADA' && loteAposFaseLances" @click="acaoImprimirRelatorioParticipantes">
        Imprimir Relatório de Participantes
      </v-btn>
      <v-btn color="primary" v-if="exibirDocumentosFornecedorVencedor" class="btn-documentos-fornecedor-vencedor" @click="abrirModalDocumentosFornecedorVencedor">
        Documentos do fornecedor
      </v-btn>
    </div>

    <v-data-table v-if="acompanhamentoDetalhes.chatLicitacao"
                  :headers="colunas" :items="acompanhamentoDetalhes.chatLicitacao"
                  :total-items="acompanhamentoDetalhes.chatLicitacao.length"
                  :loading="false" hide-actions
                  no-data-text="Não há acompanhamentos disponíveis"
                  class="az-table-list px-4 pt-2">
      <template slot="items" slot-scope="props">
        <tr>
          <td>
            {{props.item.dataHora | az-date('DD/MM/YYYY HH:mm:ss.SSS')}}
          </td>
          <td>
            {{ props.item.usuario || '-'}}
          </td>
          <td>
            {{ props.item.mensagem || '-'}}
          </td>
        </tr>
      </template>
    </v-data-table>

    <modal-confirmar-captcha-download
      :exibir="exibirModalConfirmarCaptchaDownload"
      :item="documentoDownload"
      :licitacaoId="Number(licitacaoId)"
      max-width="335"
      @fecharModal="exibirModalConfirmarCaptchaDownload=false"
      @continuarAcao="onContinuarAcaoCaptcha"
    />

    <modal-documentos-fornecedor-vencedor
      ref="modalDocumentosFornecedorVencedor"
      @solicitarCaptchaDownload="abrirModalConfirmarCaptchaDownload"
    />
  </div>
</template>
<script>
import modalConfirmarCaptchaDownload from '@/views/components/ModalConfirmarCaptchaDownload'
import ModalDocumentosFornecedorVencedor from '@/views/components/ModalDocumentosFornecedorVencedor'
import { mapState } from 'vuex'
import { normalizarCasasDecimais } from '@/core/utils/CasasDecimaisUtils'

export default {
    name: 'AcompanhamentoTabela',
    components: { modalConfirmarCaptchaDownload, ModalDocumentosFornecedorVencedor },
    props:{
        acompanhamentoDetalhes:{
            type: Object,
            default: () => ({})
        },
        situacao:{
            type: String,
        },
        licitacaoId: {
            type: [String, Number],
            required: true
        },
        loteId: {
            type: [String, Number],
            default: ''
        },
        fase: {
            type: String,
            default: ''
        },
        ehMelhorTecnica: {
            type: Boolean,
            default: false
        },
        possuiVencedor: {
            type: Boolean,
            default: false
        }
    },
    data(){
        return{
            colunas: [
                {
                    value: 'dataHora',
                    text: 'Data/Hora',
                    align: 'left',
                    width: '12%',
                    sortable: false,
                    class: 'primary--text'
                },
                {
                    value: 'usuario',
                    text: 'Usuário',
                    align: 'left',
                    width: '16%',
                    sortable: false,
                    class: 'primary--text'
                },
                {
                    value: 'mensagem',
                    text: 'Mensagem',
                    align: 'left',
                    width: '50%',
                    sortable: false,
                    class: 'primary--text'
                },
            ],
            exibirModalConfirmarCaptchaDownload: false,
            documentoDownload: {},
            fasesPregaoEletronico: [
                'AGUARDANDO ABERTURA DE PROPOSTAS',
                'LANCES',
                'ABERTURA DE VISTAS',
                'HABILITAÇÃO',
                'RECURSO',
                'ADJUDICAÇÃO'
            ]
        }
    },
    computed: {
        ...mapState(['parametros', 'licitacao']),
        casasDecimaisQuantidade() {
            const casasDecimaisConfiguradas = this.acompanhamentoDetalhes.casasDecimaisQuantidade !== null
                && this.acompanhamentoDetalhes.casasDecimaisQuantidade !== undefined
                ? this.acompanhamentoDetalhes.casasDecimaisQuantidade
                : (this.licitacao || {}).casasDecimaisQuantidade
            return normalizarCasasDecimais(casasDecimaisConfiguradas)
        },
        quantidadeFormatada() {
            const quantidade = this.acompanhamentoDetalhes.quantidade
            if (quantidade === null || quantidade === undefined || quantidade === '') {
                return quantidade
            }
            return this.valorFormatado(Number(quantidade), this.casasDecimaisQuantidade)
        },
        mesesPeriodicidade(){
          return Number(this.acompanhamentoDetalhes.periodicidade)
        },
        itemEhPeriodico(){
          return this.mesesPeriodicidade > 0
        },
        valorTotalPeriodoFormatado(){
          return this.valorInformativoFormatado(this.acompanhamentoDetalhes.valorTotalEstimado)
        },
        valorMedioMensalFormatado(){
          const valorTotalPeriodo = this.acompanhamentoDetalhes.valorTotalEstimado
          if (!valorTotalPeriodo) {
            return this.valorInformativoFormatado(valorTotalPeriodo)
          }
          return this.valorInformativoFormatado(valorTotalPeriodo / this.mesesPeriodicidade)
        },
        recaptchaDownloadPubAtivo(){
            return this.parametros && this.parametros.recaptchaDownloadPubAtivo
        },
        exibirRelatorioHistoricoLancesAreaPublica(){
            return this.parametros && this.parametros.exibirRelatorioHistoricoLancesAreaPublica === true
        },
        exibirRelatorioParticipantesAreaPublica(){
            return this.parametros && this.parametros.exibirRelatorioParticipantesAreaPublica === true
        },
        exibirDocumentosFornecedorVencedor(){
            return !!this.parametros && this.parametros.exibirDocumentosFornecedorVencedorAreaPublica
                && this.possuiVencedor
        },
        loteAposFaseLances(){
            const indexFaseAtual = this.fasesPregaoEletronico.indexOf(this.formatarFase(this.fase))
            const indexFaseLances = this.fasesPregaoEletronico.indexOf('LANCES')
            return indexFaseAtual > indexFaseLances
        }
    },
    methods: {
        valorInformativoFormatado(valor) {
            if (!this.acompanhamentoDetalhes.mostrarValorReserva) {
                return 'Sigiloso'
            }
            return `R$ ${this.valorFormatado(valor, this.acompanhamentoDetalhes.casasDecimais)}`
        },
        valorFormatado(valor, casasDecimais) {
            if(valor) {
                const numArr = valor.toFixed(normalizarCasasDecimais(casasDecimais)).split('.')
                const parteInteira = numArr[0].split('').reverse().reduce(function (acc, num, i) {
                    const separator = i && !(i % 3) ? '.' : ''
                    return num === '-' ? acc : num + separator + acc
                }, '')
                return numArr[1] === undefined ? parteInteira : parteInteira + ',' + numArr[1]
            }
            return '0,00'
        },
        acaoImprimirHistorico(){
            if (this.recaptchaDownloadPubAtivo) {
                const item = { acao: 'IMPRIMIR_HISTORICO' }
                this.abrirModalConfirmarCaptchaDownload(item)
            } else {
                this.imprimirHistorico()
            }
        },
        acaoImprimirRelatorioParticipantes(){
            if (this.recaptchaDownloadPubAtivo) {
                const item = { acao: 'IMPRIMIR_RELATORIO_PARTICIPANTES' }
                this.abrirModalConfirmarCaptchaDownload(item)
            } else {
                this.imprimirRelatorioParticipantes()
            }
        },
        abrirModalDocumentosFornecedorVencedor(){
            this.$refs.modalDocumentosFornecedorVencedor.open({
                licitacaoId: this.licitacaoId,
                loteId: this.loteId
            })
        },
        abrirModalConfirmarCaptchaDownload(documento) {
            this.documentoDownload = documento || {}
            this.exibirModalConfirmarCaptchaDownload = true
        },
        async onContinuarAcaoCaptcha(itemConfirmado){
            if (!itemConfirmado || !itemConfirmado.acao) return
            if (itemConfirmado.acao === 'IMPRIMIR_HISTORICO') {
                this.imprimirHistorico()
            } else if (itemConfirmado.acao === 'IMPRIMIR_RELATORIO_PARTICIPANTES') {
                this.imprimirRelatorioParticipantes()
            } else if (itemConfirmado.acao === 'BAIXAR_DOCUMENTO_FORNECEDOR') {
                await this.$refs.modalDocumentosFornecedorVencedor.baixarDocumento(itemConfirmado.documento, itemConfirmado.captchaResponse)
            }
        },
        imprimirHistorico() {
            const idPregao = this.licitacaoId
            const idLote = this.loteId || ''
            const fase = this.fase || ''

            if (!idPregao) {
                console.warn('imprimirHistorico: id da licitação não encontrado.')
                return
            }

            const params = `?lote=${encodeURIComponent(idLote)}&fase=${encodeURIComponent(fase)}`
            const url = `/licitacao/api/public/v1/licitacoes/${encodeURIComponent(idPregao)}/relatorios/imprimirHistoricoLancesPublico${params}`

            if (typeof window.openGreyBox === 'function') {
                window.openGreyBox('Imprimir Histórico de Lances', url, 900, 700)
                return
            }
            const features = 'toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=900,height=700'
            window.open(url, '_blank', features)
        },
        imprimirRelatorioParticipantes() {
            const idPregao = this.licitacaoId
            const idLote = this.loteId || ''

            if (!idPregao) {
                console.warn('imprimirRelatorioParticipantes: id da licitação não encontrado.')
                return
            }
            if (!idLote) {
                console.warn('imprimirRelatorioParticipantes: id do lote não encontrado.')
                return
            }

            const params = `?lote=${encodeURIComponent(idLote)}`
            const url = `/licitacao/api/public/v1/licitacoes/${encodeURIComponent(idPregao)}/relatorios/imprimirRelatorioParticipantesPublico${params}`

            if (typeof window.openGreyBox === 'function') {
                window.openGreyBox('Imprimir Relatório de Participantes', url, 900, 700)
                return
            }
            const features = 'toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=900,height=700'
            window.open(url, '_blank', features)
        },
        formatarFase(fase) {
            const faseNormalizada = (fase || '').toUpperCase()
            if (faseNormalizada === 'HABILITACAO') return 'HABILITAÇÃO'
            if (faseNormalizada === 'ADJUDICACAO') return 'ADJUDICAÇÃO'
            if (faseNormalizada === 'JULGAMENTO') return 'ABERTURA DE VISTAS'
            return faseNormalizada
        }
    }
}

</script>

<style lang="stylus">
    .periodicidade-acompanhamento {
        align-items: center;
        display: flex;
    }
    .periodicidade-acompanhamento__icone {
        color: #1687d4 !important;
        cursor: default;
        font-size: 16px;
        margin-left: 4px;
    }
    .tooltip-periodicidade-acompanhamento {
        background-color: #ffffff !important;
        border: 1px solid #e0e0e0;
        border-radius: 3px;
        box-shadow: 0 3px 10px rgba(0, 0, 0, .25);
        color: #1f1f1f !important;
        font-size: 12px;
        line-height: 1.8;
        opacity: 1 !important;
        padding: 14px 16px !important;
    }
    .tooltip-periodicidade-acompanhamento__titulo {
        color: #0067b1;
        font-weight: 600;
        margin-bottom: 6px;
    }
    .tooltip-periodicidade-acompanhamento__divisor {
        border-top: 1px solid #dddddd;
        margin: 10px 0;
    }
    .tooltip-periodicidade-acompanhamento__aviso {
        color: #757575;
        font-size: 11px;
        line-height: 1.5;
    }
    .legenda-periodicidade {
        align-items: flex-start;
        color: #555;
        display: flex;
        font-size: 11px;
        line-height: 1.45;
        margin-top: 12px;
    }
    .legenda-periodicidade .v-icon {
        color: #1687d4 !important;
        font-size: 16px;
        margin: 0 4px 0 0;
    }
    .legenda-periodicidade__titulo {
        color: #0067b1;
    }
    .legenda-periodicidade div div + div {
        margin-top: 1px;
    }
</style>